// Ported from vlookup-dramatic/app/home-audience.tsx by scripts/revamp/port-design.js
import React from "react";
import Image from "../../components/image";
import Link from "../../components/link";
import { ArrowUpRight } from "../../lib/icons";
import { audienceSection } from "../../lib/content";
import { HomeReveal } from "./home-reveal";
/*
 * "What brings you here today?" — 4 horizontal audience cards.
 * Desktop: a single expanding row — hovering (or keyboard-focusing) a card
 * grows it while its neighbours compress, revealing the description and CTA
 * over the photograph. Mobile/tablet: stacked cards, fully revealed.
 * Pure CSS interactivity (flex-grow + grid-rows transitions), no JS.
 */
export function HomeAudience() {
  const cards = audienceSection.cards;
  return (<section id="join" className="relative isolate overflow-hidden py-14 md:py-20">
    {/* signature blob motif, bleeding off the right edge */}

    <div className="wrap">
      <div className="max-w-2xl">
        <span className="inline-flex items-center gap-2.5 text-xs font-bold uppercase tracking-[0.2em] text-brand-red">
          <span className="h-px w-8 bg-current opacity-50" />
          Choose your path
        </span>
        <h2 className="mt-5 text-4xl font-semibold leading-[1.05] text-heading md:text-6xl">
          What brings you here{" "}
          <em className="font-normal italic text-brand-red">today?</em>
        </h2>
        <p className="mt-5 max-w-xl text-lg leading-relaxed text-muted-foreground">
          {audienceSection.sub}
        </p>
      </div>

      <HomeReveal className="mt-10">
        <div className="flex flex-col gap-4 lg:h-[470px] lg:flex-row">
          {cards.map((c) => (<Link key={c.title} href={c.href} className="group relative flex min-h-[340px] flex-col justify-end overflow-hidden rounded-[2rem] bg-black p-6 shadow-sm transition-[flex-grow,box-shadow] duration-500 ease-[cubic-bezier(0.32,0.72,0,1)] hover:shadow-2xl focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-brand-red/50 md:p-7 lg:min-h-0 lg:basis-0 lg:grow lg:hover:grow-[2.6] lg:focus-visible:grow-[2.6]">
            {/* photograph + scrim */}
            <Image src={c.img} alt="" fill sizes="(max-width: 1024px) 100vw, 45vw" className="object-cover transition-transform duration-700 group-hover:scale-105" />
            <span aria-hidden className="absolute inset-0 audience-scrim" />
            {/* QA row 34: below lg the desc + CTA are always shown, so back
                    them with a solid tint — the hover-tuned scrim alone leaves
                    the text unreadable over bright photos. */}
            <span aria-hidden className="absolute inset-0 bg-black/50 lg:hidden" />

            {/* bottom block: title always visible, desc + CTA revealed on hover (lg) */}
            <span className="relative block">
              <span className="block font-display text-xl font-semibold leading-snug text-cream md:text-2xl">
                {c.title}
              </span>
              <span className="grid grid-rows-[1fr] transition-[grid-template-rows] duration-500 ease-[cubic-bezier(0.32,0.72,0,1)] lg:grid-rows-[0fr] lg:group-hover:grid-rows-[1fr] lg:group-focus-visible:grid-rows-[1fr]">
                <span className="block min-h-0 overflow-hidden">
                  <span className="mt-3 block text-sm leading-relaxed text-cream/85 transition-opacity delay-100 duration-500 lg:opacity-0 lg:group-hover:opacity-100 lg:group-focus-visible:opacity-100">
                    {c.desc}
                  </span>
                  {/* red-dark is the resting colour, not a hover state: above lg
                          the pill is only ever visible while the card is hovered, so
                          darkening on hover left the always-visible mobile pill (and a
                          keyboard-focused card) the only place the lighter red showed. */}
                  <span className="mb-1 mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-brand-red-dark px-5 py-2.5 text-sm font-bold text-white transition-opacity delay-150 duration-500 lg:opacity-0 lg:group-hover:opacity-100 lg:group-focus-visible:opacity-100">
                    {c.cta}
                    <ArrowUpRight className="size-4" />
                  </span>
                </span>
              </span>
            </span>
          </Link>))}
        </div>
      </HomeReveal>
    </div>
  </section>);
}
